module.exports = __webpack_public_path__ + "static/media/ic_bse_white.a8eee2e5.svg";